import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import { FormStepper } from "../../../common";
import globalstyles from "../../../../assets/styles/base/globalPage.module.scss";
import { pathConstants } from "../../../../routes/pathContants";

export const SmsFormCover = () => {
  const { id } = useParams();
  const { pathname } = useLocation();
  const splitPath = pathname.split("/");
  const navigate = useNavigate();

  const steps = [
    {
      title: "context",
      id: 0,
      route: pathConstants?.MARKETING_SMS_CAMPAIGNS_CONTEXT({ id }),
    },
    {
      title: "audience",
      id: 1,
      route: pathConstants?.MARKETING_SMS_CAMPAIGNS_AUDIENCE({ id }),
    },
    {
      title: "content",
      id: 2,
      route: pathConstants?.MARKETING_SMS_CAMPAIGNS_CONTENT({ id }),
    },
    {
      title: "schedule",
      id: 3,
      route: pathConstants?.MARKETING_SMS_CAMPAIGNS_SCHEDULE({ id }),
    },
    {
      title: "review",
      id: 4,
      route: pathConstants?.MARKETING_SMS_CAMPAIGNS_REVIEW({ id }),
    },
  ];

  const step = splitPath[splitPath.length - 1] ?? "context";
  const currentStep = steps?.find((item) => item?.title === step);

  return (
    <div className="mt-4">
      <FormStepper
        steps={steps}
        currentStep={currentStep?.id}
        navigateToStep={(step_id) => {
          const route = steps?.find((item) => item?.id === step_id)?.route;
          navigate(route);
        }}
      />

      <div
        className={`${globalstyles["cardWithBackground"]} white mt-4 p-2 p-md-4`}
      >
        <Outlet />
      </div>
    </div>
  );
};
